<template>
  <div
    class="modal fade"
    tabindex="-1"
    id="subscription-modal"
    ref="newTargetModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-750px">
      <div class="modal-content rounded">
        <div class="modal-header">
          <h5 class="modal-title">{{ translate("dashboard_subscription_details") }}</h5>

          <button
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            aria-label="Close"
            @click="closeModal"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="modal-body rounded p-10">
          <div class="overflow-auto h-300px">
            <table class="table align-middle gs-0 gy-4 position-relative">
              <thead style="table-layout: fixed">
                <tr class="fw-bold text-muted bg-light">
                  <th class="ps-4 min-w-50px rounded-start">{{ translate("dashbodard_begin_date") }}</th>
                  <th class="min-w-50px text-center">{{ translate("dashboard_end_date") }}</th>
                  <th class="min-w-50px text-center">{{ translate("dashbord_total_rights") }}</th>
                  <th class="min-w-50px text-center">{{ translate("dashboard_remaining_rights") }}</th>
                  <th class="min-w-50px text-center rounded-end">{{ translate("dashboard_status") }}</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr
                  v-for="subscription in subscriptionList"
                  :key="subscription.Id"
                >
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="d-flex justify-content-start flex-column">
                        <a class="text-dark fw-bold mb-1 fs-6 ms-2">{{ convertDate(subscription.BeginDate) }} </a>
                      </div>
                    </div>
                  </td>

                  <td>
                    <a class="text-dark fw-bold d-block mb-1 fs-6">{{ convertDate(subscription.EndDate) }}</a>
                  </td>

                  <td>
                    <a class="text-dark fw-bold d-block mb-1 fs-6">{{ subscription.TotalQuota }}</a>
                  </td>

                  <td>
                    <a class="text-dark fw-bold d-block mb-1 fs-6">{{ subscription.RemainingQuota }}</a>
                  </td>

                  <td>
                    <span
                      v-if="!subscription.Status"
                      class="badge badge-light-danger fs-7 fw-bold"
                      >{{ translate("dashboard_passive") }}</span
                    >
                    <span
                      v-else
                      class="badge badge-light-success fs-7 fw-bold"
                      >{{ translate("location_modal_check_label") }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Pagination
            @onPage="onPage"
            :TotalData="subscriptionList.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();

const newTargetModalRef = ref(null);

const subscriptionList = ref([]);

const convertDate = (payload) => {
  const date = new Date(payload);
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  return dd + "." + mm + "." + yyyy;
};

const filterObj = ref({
  pageIndex: 1,
  pageSize: 10,
});

const getData = () => {
  store.dispatch("DashboardModule/GET_COMPANY_QUATO", filterObj.value).then((response) => {
    subscriptionList.value = response.CompanyQuotaHomeModels;
  });
};

const closeModal = () => {
  hideModal(newTargetModalRef.value);
};

getData();
const onPage = (e) => {
  filterObj.value.pageIndex = e.step.value;
  filterObj.value.pageSize = e.pageSize.value;
  getData();
};

const clearForm = () => {
  filterObj.value.pageIndex = 1;
  filterObj.value.pageSize = 10;
};
onMounted(() => {
  document.getElementById("subscription-modal").addEventListener("hide.bs.modal", () => {
    clearForm();
  });
});
</script>
